export default __webpack_public_path__ + "static/media/Q4_4.2cac3677.jpg";